import { TerrariumPlant } from './TerrariumPlant'
import useSettingsStore from '../store/settingsStore'
import useBitsStore from '../store/bitsStore'

function getNameColor(userId) {
  const colors = ['#ff6b6b', '#ffd93d', '#6bcf7f', '#74b9ff', '#a29bfe', '#fd79a8', '#ff9ff3', '#54a0ff', '#5f27cd', '#01a3a4']
  let hash = 0
  for (let i = 0; i < userId.length; i++) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash)
  }
  return colors[Math.abs(hash) % colors.length]
}

export function TerrariumPlantSlot({ plant }) {
  const settings = useSettingsStore((state) => state.settings)
  const hasVip = useBitsStore((state) => state.hasReachedPerk(plant.userId, 'vip_badge'))
  const hasNameColor = useBitsStore((state) => state.hasCosmetic(plant.userId, 'name_color'))
  const nameColorValue = hasNameColor ? getNameColor(plant.userId) : undefined
  const displayName = plant.customName || plant.username

  const className = [
    'plant-slot',
    plant.spawning ? 'spawning' : '',
    plant.despawning ? 'despawning' : '',
    plant.isWatering ? 'watering-active' : '',
    plant.isBlooming ? 'blooming' : '',
    plant.isWaving ? 'waving' : '',
    plant.isShaking ? 'shaking' : ''
  ].filter(Boolean).join(' ')

  return (
    <div
      className={className}
      style={{ left: `${plant.position.x}%` }}
    >
      {settings.showChatBubbles && plant.chatMessage && (
        <div className="entity-chat-bubble">
          <span>{plant.chatMessage}</span>
        </div>
      )}
      <TerrariumPlant plant={plant} compact={true} />
      {settings.showUsernames && (
        <div className="entity-username" style={nameColorValue ? { color: nameColorValue } : undefined}>
          {hasVip && <span className="vip-badge">⭐</span>}
          {displayName}
        </div>
      )}
      {plant.isWatering && settings.showWaterParticles && (
        <div className="plant-water-drops">
          {Array.from({ length: 5 }, (_, i) => (
            <div
              key={i}
              className="mini-water-drop"
              style={{
                left: `${20 + Math.random() * 60}%`,
                animationDelay: `${Math.random() * 0.5}s`
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default TerrariumPlantSlot